import React from 'react';
import DatePicker from 'react-datepicker';
import { Portal } from 'react-overlays';
import BaseComponent from '../../baseClasses/BaseComponent';
import moment from 'moment';
import './DatePicker.scss';
import dataModel from '../../models/DataModel';

class Datepicker extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {};

    this.onCalendarClose = this.onCalendarClose.bind(this);
  }
  
  isValidDateFormat(dateString) {
    const datePattern = /^(0?[1-9]|1[0-2])?\/?(0?[1-9]|[0-2]?[0-9]|3[0-1])?\/?\d{4}$/;
  
    if (datePattern.test(dateString)) {
      return true;
    }
    return false;
  }

  handleSelection(d) {
    const { handleDateSelection } = this.props;
    if (handleDateSelection) {
      handleDateSelection(d ? moment(d).format('YYYY-MM-DD') : null);
    }
    this.setState({ selectedDate: d });
  }

  handleRawchange(e){
    const monthRegex = /^(0?[0-9]|1[0-2])$/;
    const monthAndDateRegex = /^(0?[0-9]|1[0-2])\/(0?[0-9]|[12]\d|3[01])?$/;
    const yearRegex = /^\d{1,2}\/\d{1,2}\/?\d{0,4}$/;
    const value = e.target.value;
    const isValueValid = this.isValidDateFormat(value);

    if(value){
      if(value.length < 3){
        if(!monthRegex.test(value)){
          this.setState({ selectedDate: null, selected: null });
          e.target.value = null;
          dataModel.displayInfoErrorMessage('Input date is Invalid!.', 1000, 2);
        }
      }
      else if(value.length < 6){
        if(!monthAndDateRegex.test(value)){
          this.setState({ selectedDate: null, selected: null });
          e.target.value = null;
          dataModel.displayInfoErrorMessage('Input date is Invalid!.', 1000, 2);
        }
      }
      else if(value.length < 10){
        if(!yearRegex.test(value)){
          this.setState({ selectedDate: null, selected: null });
          e.target.value = null;
          dataModel.displayInfoErrorMessage('Input date is Invalid!.', 1000, 2);
        }
      }
      else{
        if(!isValueValid){
          this.setState({ selectedDate: null, selected: null });
          e.target.value = null;
          dataModel.displayInfoErrorMessage('Input date is Invalid!.', 1000, 2);
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetSelection != this.props.resetSelection && this.props.resetSelection) {
      this.setState({ selectedDate: null });
      if (this.props.handleResetSelection) {
        this.props.handleResetSelection();
      }
    }
  }

  onCalendarClose(){
    if(this.props.onCalendarClose){
      this.props.onCalendarClose();
    }
  }

  render() {
    const { selected, width, placeHolderText, startToday, popperPlacement, locale } = this.props;
    const { selectedDate } = this.state;

    let date = selectedDate ? selectedDate : (selected ? moment(selected) : null);
    let style = {};
    if (width) {
      style = { width: width + 'px' };
    }
    let minDate;
    if(this.props.minDate){
      minDate = moment(this.props.minDate);
    }
    let maxDate;
    if(this.props.maxDate) {
      maxDate = moment(this.props.maxDate);
    }
    if(startToday){
      minDate = moment(new Date());
    }

    const calendarContainer = ({ children }) => {
      const el = document.getElementById('calendar-portal');

      return (
        <Portal container={el}>
          {children}
        </Portal>
      );
    };

    return (
      <div className="datepicker" style={style}>
        <DatePicker
          className="due-date-picker"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          placeholderText={placeHolderText ? placeHolderText : '(Enter Date)'}
          minDate={minDate ? (minDate.toDate ? minDate.toDate() : minDate) : null}
          maxDate={maxDate ? (maxDate.toDate ? maxDate.toDate() : maxDate) : null}
          selected={date ? (date.toDate ? date.toDate() : date) : null}
          onChange={this.handleSelection}
          onChangeRaw={(e)=> this.handleRawchange(e)}
          popperPlacement={popperPlacement}
          popperContainer={calendarContainer}
          locale={locale}
          onCalendarClose={this.onCalendarClose}
        />
      </div>
    );
  }
}

export default Datepicker;



// WEBPACK FOOTER //
// ./src/components/DatePicker/index.js